import { Component, OnInit, Input } from '@angular/core';
import { HeaderService } from '../../../core/services/header.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ObjectService } from '../../../core/services/object.service';
import { LoadingState } from '../../../core/components/loading/loading.component';
import { forkJoin } from 'rxjs';
import { UserService } from '../../../core/services/user.service';
import { RolesService } from '../../../core/services/roles.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-permission-tab',
  templateUrl: './user-permission-tab.component.html',
  styleUrls: ['./user-permission-tab.component.scss']
})
export class UserPermissionTabComponent implements OnInit {

  objectList: any = [];
  checkAll: boolean;
  selectedTree: any = [];
  blukAction: any = null;
  @Input() isChecked: boolean;
  @Input() expandable: boolean;
  @Input() IS_DISABLE: boolean;
  @Input() highlight: boolean;
  @Input() isAccessChange: boolean;
  @Input() mou_permisson: string;
  @Input() userId: number;
  @Input() appName: string;
  @Input() roleName: string;
  @Input() appId: number;
  @Input() roleId: number;
  loading: LoadingState = LoadingState.NotReady;
  mou_other_permisson_details: any = [];
  userDetails: any;
  userPermissionList: any = [];
  rolePermissionList: any = [];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private headerService: HeaderService,
    private objectService: ObjectService,
    private userService: UserService,
    private toastrService: ToastrService,
    private rolesService: RolesService
  ) { }

  ngOnInit() {
    this.loadData()
  }

  loadData() {

    var forkArray = [];
    forkArray.push(this.objectService.getmoduleObjectList(this.appName))
    forkArray.push(this.rolesService.getRolePermission(this.appName, this.roleName))
    forkArray.push(this.userService.permissionListByUser(this.appName, this.userId))
    forkJoin(forkArray).subscribe(
      ([objectData, roleData, userPermissionData]) => {
        this.objectList = objectData['result']
        this.rolePermissionList = roleData['result']
        this.userPermissionList = userPermissionData['result']
        console.log(this.objectList)
        console.log(this.userPermissionList)
        if (this.userPermissionList.length > 0) {
          this.userPermissionList.forEach(x => {
            this.objectList.forEach(y => {
              this.assignData(x, y)
            })
          })
        }
        else {
          this.rolePermissionList.forEach(x => {
            this.objectList.forEach(y => {
              this.assignR_Data(x, y)
            })
          })
        }

        this.loading = LoadingState.Ready;
      },
      err => {
        this.loading = LoadingState.Ready;
        console.log(err)
      }
    )
  }

  assignData(item, data) {
    if (item.mou_other == data.id) {
      this.onAccessChange(item.mou_permissions_n, data)
    }
    if (data.child.length > 0) {
      data.child.forEach(x => {
        this.assignData(item, x)
      })
    }
  }

  assignR_Data(item, data) {
    if (item.mor_other == data.id) {
      this.onAccessChange(item.mor_permissions_n, data)
    }
    if (data.child.length > 0) {
      data.child.forEach(x => {
        this.assignData(item, x)
      })
    }
  }

  getAccessValue(item) {
    if (item.mou_permisson == '1') {
      return "Read"
    }
    else if (item.mou_permisson == '2') {
      return "Write"
    }
    else if (item.mou_permisson == '3') {
      return "Execute"
    }
    else {
      return "No Access"
    }
  }

  onBulkAccessChange($event) {
    this.selectedTree.forEach(x => {
      this.onAccessChange($event, x)
    })

    setTimeout(() => {
      this.blukAction = null;
    })
  }

  onAccessChange($event, item) {
    item.mou_permisson = $event
    if (item.child.length > 0) {
      item.child.forEach(k => {
        var data = item.permission_list.filter(x => x.id <= $event)
        k['permission_list'] = data
        this.onAccessChildChange($event, k)
      })
    }
    if (item.cot_parent_id != 0) {
      this.objectList.forEach(k => {
        this.onAccessOverride(k, item, $event)
      })
    }
    this.mouseLeave(item)
  }

  onAccessOverride(item, data, $event) {
    if (item.id == data.cot_parent_id) {
      if (item.mou_permisson < $event) {
        data.mou_permisson = item.mou_permisson
      }
      if (item.cot_parent_id != 0) {
        this.objectList.forEach(k => {
          this.onAccessOverride(k, item, $event)
        })
      }
    }
    else {
      item.child.forEach(m => {
        this.onAccessOverride(m, data, $event)
      })
    }
  }

  mouseEnter(item) {
    item.isAccessChange = true;
  }

  mouseLeave(item) {
    item.isAccessChange = false;
  }

  onAccessChildChange($event, item) {
    item.mou_permisson = $event
    if (item.child.length > 0) {
      item.child.forEach(k => {
        var data = item.permission_list.filter(x => x.id <= $event)
        k['permission_list'] = data
        this.onAccessChildChange($event, k)
      })

    }
  }

  treeAllChange(checked) {
    this.checkAll = checked
    this.objectList.forEach(x => {
      this.userAccessChange(checked, x)
      if (x.child.length > 0) {
        x.child.forEach(y => {
          this.nastedTreeAllChange(checked, y)
        })
      }

    })
  }

  nastedTreeAllChange(checked, x) {
    this.userAccessChange(checked, x)
    if (x.child.length > 0) {
      x.child.forEach(y => {
        this.nastedTreeAllChange(checked, y)
      })
    }
  }

  userAccessChange(checked, item) {
    item.isChecked = checked
    if (item.child.length > 0) {
      item.child.forEach(x => {
        this.changeLoopAccess(x, checked)
      })
    }
    if (item.cot_parent_id != 0) {
      this.objectList.forEach(k => {
        this.reverseAccessChange(k, item.cot_parent_id, checked)
      })
    }

    this.selectedTree = [];
    this.objectList.forEach(a => {
      this.createSelectedTreeList(a)
    })

    this.traverseAllCheck()
  }

  toggleMenu(item) {
    item.expandable = !item.expandable
  }

  changeLoopAccess(item, checked) {
    item.isChecked = checked
    if (item.child.length > 0) {
      item.child.forEach(x => {
        this.changeLoopAccess(x, checked)
      })
    }
  }

  reverseAccessChange(item, cot_parent_id, checked) {
    if (item.id == cot_parent_id) {
      var isParantChecked = true;
      item.child.forEach(z => {
        if (!z.isChecked) {
          isParantChecked = false;
        }
      })
      item.isChecked = isParantChecked
      if (item.isChecked) {
        item.child.forEach(z => {
          this.changeLoopAccess(z, checked)
        })
        this.userAccessChange(checked, item)
      }
      else {
        this.objectList.forEach(k => {
          this.reverseAccessChange(k, item.cot_parent_id, checked)
        })
      }
    }
    else {
      item.child.forEach(m => {
        this.reverseAccessChange(m, cot_parent_id, checked)
      })
    }
  }

  createSelectedTreeList(item) {
    if (item.isChecked) {
      this.selectedTree.push(item)
    }
    if (item.child.length > 0) {
      item.child.forEach(x => {
        this.createSelectedTreeList(x)
      })
    }
  }

  traverseAllCheck() {
    this.checkAll = true;
    this.objectList.forEach(x => {
      if (!x.isChecked) {
        this.checkAll = false
      }
      else if (x.child.length > 0) {
        x.child.forEach(y => {
          this.traverseLoopAllCheck(y)
        })
      }
    })
  }

  traverseLoopAllCheck(x) {
    if (!x.isChecked) {
      this.checkAll = false
    }
    else if (x.child.length > 0) {
      x.child.forEach(y => {
        this.traverseLoopAllCheck(y)
      })
    }
  }

  getDisabled() {
    this.mou_other_permisson_details = [];
    this.objectList.forEach(x => {
      this.Set_mou_other_permisson_details(x)
    })
    if (this.mou_other_permisson_details.length == 0) {
      return true
    }
    else {
      return false;
    }
  }

  Set_mou_other_permisson_details(item) {
    if (item.mou_permisson != undefined) {
      var d = {
        mou_other: item.id,
        mou_permisson: +item.mou_permisson
      }
      this.mou_other_permisson_details.push(d)
    }
    if (item.child.length > 0) {
      item.child.forEach(x => {
        this.Set_mou_other_permisson_details(x)
      })
    }
  }

  save() {
    this.mou_other_permisson_details = [];
    this.objectList.forEach(x => {
      this.Set_mou_other_permisson_details(x)
    })
    console.log(this.mou_other_permisson_details)
    var data = {
      mou_module: this.appId,
      mou_user: this.userId,
      mou_role: this.roleId,
      mou_other_permisson_details: this.mou_other_permisson_details
    }
    this.loading = LoadingState.Processing
    this.userService.assignUserPermission(data).subscribe(
      res => {
        console.log(res)
        this.toastrService.success("Permission Updated", '', { timeOut: 5000 });
        this.loading = LoadingState.Ready;
      },
      error => {
        console.log(error)
        this.toastrService.error(error.error.msg, '', { timeOut: 5000 });
        this.loading = LoadingState.Ready;
      }
    )
  }

}
